export const publicUrls = [
    "/PublicSession",
    "/PublicSessionInfo", 
    "/user/email-confirm", 
    "/user/forgot-password", 
    "/user/reset-password", 
    "/adfs", 
    "/authenticate", 
    "/public/attachment/viewer", 
    "/loggedout"
];